import React, { useState, } from 'react';
import RegionService from '../../../../../services/region';
import MainButton from '../../../../components/General/MainButton';
import { CODES } from '../../../../../utils/responseCodes';
import { simpleAlerts } from '../../../../../utils/alerts';
import AssociateSedes from '../../../../components/Region/AddRegionSede/AssociateSedes';
import MainModal from '../../../../components/General/MainModal';

const AddRegionSede = (props) => {
    const { open, handleClose, setOpenModalLoader, setTitleSpinner, dataRegion, dataRegionSedes, getRegionSedes } = props;
    const url = "'" + window.location.pathname + "'";

    const [regionSedesDelete, setRegiontSedesDelete] = useState([]);
    const [regionSedesCopy, setRegionSedesCopy] = useState(null);

    const saveAssociateSedes = async (e) => {
        e.preventDefault();
        setOpenModalLoader(true);
        setTitleSpinner('Guardando ...');
        try {
            const savePromises = regionSedesCopy.map(async (sede) => {
                try {
                    const result = await RegionService.saveRegionSedes(url, sede);
                    if (result.status === CODES.CREATE_201 && result.data.id === 0) {
                        simpleAlerts(result.data.message, "success");
                    }
                } catch (error) {
                    console.log(`Error en saveTurnoSedes: ${error}`);
                }
            });

            const deletePromises = regionSedesDelete.map(async (sede) => {
                try {
                    const result = await RegionService.deleteRegionSedes(url, sede);
                    if (result.status === CODES.DELETE_204) {
                        simpleAlerts("Relación eliminada", "success");
                    }
                } catch (error) {
                    console.log(`Error en deleteTurnoSedes: ${error}`);
                }
            });

            await Promise.all([...savePromises, ...deletePromises]);

            simpleAlerts("Fin de asociaciónes", "success");
            getRegionSedes();
            closeModal();
        } catch (error) {
            console.log(`Error en saveAssociateAreas: ${error}`);
        }
    };

    const closeModal = () => {
        return handleClose(), setRegiontSedesDelete([]), setRegionSedesCopy([]);
    }

    return (
        <>
            <MainModal
                size={'lg'}
                open={open}
                handleClose={closeModal}
                formSubmit={saveAssociateSedes}
                title={'Asociar Sedes'}
                subTitle={'Asociar nuevas sedes'}
                bodyModal={
                    <AssociateSedes
                        dataRegionSedes={dataRegionSedes}
                        regionSedesCopy={regionSedesCopy}
                        setRegionSedesCopy={setRegionSedesCopy}
                        regionSedesDelete={regionSedesDelete}
                        setRegiontSedesDelete={setRegiontSedesDelete}
                        dataRegion={dataRegion}


                    />
                }
                buttonActions={[
                    <MainButton
                        key='btn-modal-user-save1'
                        title={'Guardar'}
                        typeStyle={'outlined'}
                        color={'primary'}
                        type={'submit'}
                    />
                ]}
            />
        </>
    );
};

export default AddRegionSede;